import BaseApi from '@/api/controller/base';

const API_URL = 'docutax/';

class DocutaxApi extends BaseApi {
  constructor() {
    super(API_URL);
  }

  signup(signupForm) {
    return this.api.post('signup', signupForm);
  }

  verify(clientId, verificationCode) {
    return this.api.post(`${clientId}/verify`, verificationCode);
  }

  resendVerification(clientId) {
    return this.api.post(`${clientId}/resend-verification`, {});
  }

  fetchLocationById(locationId) {
    return this.api.get(`locations/${locationId}`);
  }

  findNearbyLocations(zipcode) {
    return this.api.get(`locations/nearby/${zipcode}`);
  }

  fetchClient() {
    return this.api.get('current-client');
  }

  findLastFiledOffice() {
    return this.api.get('current-client/suggested-office');
  }

  selectOffice(office) {
    return this.api.post('current-client/select-office', office);
  }

  getUploadUrl() {
    return this.api.get('current-client/upload-url');
  }

  submit(filesAndMessage) {
    return this.api.post('current-client/submit', filesAndMessage);
  }

  validateAndLoadRequest(requestUrlSlug, accessCode) {
    return this.api.post(`request/${requestUrlSlug}/validate-and-load`, { accessCode });
  }

  submitReplyToRequest(requestUrlSlug, replyToRequestCreateDto) {
    return this.api.post(`request/${requestUrlSlug}/reply`, replyToRequestCreateDto);
  }
}

const apiInstance = new DocutaxApi();
export { DocutaxApi, apiInstance };
export default apiInstance;
